import { createQueryData } from '../helpers/createQueryData';

const endPoint = 'Acceptance/step_address_life_cycle_by_stageId/{id}';

const { useQuery } = createQueryData({
  endPoint,
  options: {
    createParams: ({ endPoint, params }) => {
      const { stageId } = params;
      return { url: endPoint.replace('{id}', stageId) };
    },
  },
});

const useAvailableStepsQuery = ({ params: { stageId } = {}, options }) => {
  return useQuery({
    params: { stageId },
    options: {
      enabled: Boolean(stageId),
      ...options,
    },
  });
};

export { useAvailableStepsQuery };
